<div class="container">
  <ghs-header [standalone]="true"></ghs-header>

  <div class="monster-editor">
    <h1><span [ghs-label]="'editor.monster'"></span> (<span [ghs-label]="'wip'"></span>)</h1>
    <div class="columns">
      <div class="input">
        <div class="monster-stats">
          <h2><span [ghs-label]="'editor.monster.stats'"></span></h2>

          <div class="base-data dialog">
            <div class="dialog-container">
              <label><span [ghs-label]="'edition'"></span></label>
              <input [(ngModel)]="monsterData.edition" [ghs-label]="'edition'" [ghs-label-attribute]="'placeholder'"
                (change)="monsterDataToJson()" (keyup)="monsterDataToJson()">

              <label><span [ghs-label]="'editor.monster.stats.deck'"></span></label>
              <input [(ngModel)]="monsterData.deck" [ghs-label]="'editor.monster.stats.deck'"
                [ghs-label-attribute]="'placeholder'" (change)="monsterDataToJson()" (keyup)="monsterDataToJson()">

              <label><span [ghs-label]="'editor.monster.stats.boss'"></span></label>
              <input type="checkbox" [(ngModel)]="monsterData.boss" (change)="toggleBoss()">

              <label><span [ghs-label]="'editor.monster.stats.flying'"></span></label>
              <input type="checkbox" [(ngModel)]="monsterData.flying" (change)="updateType()">

              <label><span [ghs-label]="'editor.monster.stats.hidden'"></span></label>
              <input type="checkbox" [(ngModel)]="monsterData.hidden" (change)="updateType()">

              <label><span [ghs-label]="'editor.monster.stats.count'"></span></label>
              <input type="number" [(ngModel)]="monsterData.count" min="1" max="10" [ghs-label]="'editor.monster.count'"
                [ghs-label-attribute]="'placeholder'" (change)="monsterDataToJson()" (keyup)="monsterDataToJson()">
            </div>
          </div>

          <div class="level-select">
            <span class="select"><span [ghs-label]="'editor.monster.stats.levelSelect'"></span>:</span>
            <div class="level" *ngFor="let l of [] | ghsRange:8" [ngClass]="{'current' : level == l}"
              (click)="level = l; updateQueryParams()">
              {{l}}</div>
            <div class="level" [ngClass]="{'current' : level == -1}" (click)="level = -1; updateQueryParams()">
              <span [ghs-label]="'editor.monster.stats.allLevel'"></span>
            </div>
          </div>

          <div class="stats-container" *ngFor="let level of (level == -1 ? ([] | ghsRange:8) : [level])">
            <div class="stats-input" *ngIf="level != -1">
              <ghs-monster-stats class="stats-editor" [monster]="getMonsterForLevel(level)" [noClick]="true">
              </ghs-monster-stats>

              <input class="name" [(ngModel)]="monsterData.name" (change)="monsterDataToJson()"
                (keyup)="monsterDataToJson()">

              <div class="stats" *ngIf="!monsterData.boss">
                <input class="stat end" [ngModel]="statsForType(MonsterType.normal, level).health"
                  (ngModelChange)="statsForType(MonsterType.normal,level).health=valueChange($event)"
                  (change)="monsterDataToJson()" (keyup)="monsterDataToJson()">
                <input class="stat start" [ngModel]="statsForType(MonsterType.elite,level).health"
                  (ngModelChange)="statsForType(MonsterType.elite,level).health=valueChange($event)"
                  (change)="monsterDataToJson()" (keyup)="monsterDataToJson()">

                <input class="stat end" type="number" [(ngModel)]="statsForType(MonsterType.normal,level).movement"
                  (change)="monsterDataToJson()" (keyup)="monsterDataToJson()">
                <input class="stat start" type="number" [(ngModel)]="statsForType(MonsterType.elite,level).movement"
                  (change)="monsterDataToJson()" (keyup)="monsterDataToJson()">

                <input class="stat end" [ngModel]="statsForType(MonsterType.normal,level).attack"
                  (ngModelChange)="statsForType(MonsterType.normal,level).attack=valueChange($event)"
                  (change)="monsterDataToJson()" (keyup)="monsterDataToJson()">
                <input class="stat start" [ngModel]="statsForType(MonsterType.elite,level).attack"
                  (ngModelChange)="statsForType(MonsterType.elite,level).attack=valueChange($event)"
                  (change)="monsterDataToJson()" (keyup)="monsterDataToJson()">

                <input class="stat end" type="number" [(ngModel)]="statsForType(MonsterType.normal,level).range"
                  (change)="monsterDataToJson()" (keyup)="monsterDataToJson()">
                <input class="stat start" type="number" [(ngModel)]="statsForType(MonsterType.elite,level).range"
                  (change)="monsterDataToJson()" (keyup)="monsterDataToJson()">
              </div>

              <div class="stats boss" *ngIf="monsterData.boss">
                <input class="stat end" [ngModel]="statsForType(MonsterType.boss,level).health"
                  (ngModelChange)="statsForType(MonsterType.boss,level).health=valueChange($event)"
                  (change)="monsterDataToJson()" (keyup)="monsterDataToJson()">

                <input class="stat end" type="number" [(ngModel)]="statsForType(MonsterType.boss,level).movement"
                  (change)="monsterDataToJson()" (keyup)="monsterDataToJson()">

                <input class="stat end" [ngModel]="statsForType(MonsterType.boss,level).attack"
                  (ngModelChange)="statsForType(MonsterType.boss,level).attack=valueChange($event)"
                  (change)="monsterDataToJson()" (keyup)="monsterDataToJson()">

                <input class="stat end" type="number" [(ngModel)]="statsForType(MonsterType.boss,level).range"
                  (change)="monsterDataToJson()" (keyup)="monsterDataToJson()">
              </div>

              <ng-container *ngIf="!monsterData.boss">
                <div class="extra normal">
                  <div class="notes" [ghs-label]="statsForType(MonsterType.normal,level).note"></div>
                  <div class="additional" cdkDropList
                    (cdkDropListDropped)="dropMonsterAction(MonsterType.normal,level,$event)">
                    <div class="monster-action" *ngFor="let action of statsForType(MonsterType.normal,level).actions"
                      cdkDrag>
                      <span class="handle" cdkDragHandle><img class="ghs-icon" src="./assets/images/menu.svg"></span>
                      <ghs-action (click)="editMonsterAction(MonsterType.normal, action,level)" [action]="action"
                        [monster]="getMonsterForLevel(level)" [inline]="true" [right]="true" [hexSize]="0.5"
                        [relative]="true">
                      </ghs-action>
                    </div>
                    <a (click)="addMonsterAction(MonsterType.normal,level)"><img class="ghs-icon"
                        src="./assets/images/plus.svg"> <span [ghs-label]="'editor.action.add'"></span></a>
                  </div>
                </div>
                <div class="extra elite">
                  <div class="notes" [ghs-label]="statsForType(MonsterType.elite,level).note"></div>
                  <div class="additional" cdkDropList
                    (cdkDropListDropped)="dropMonsterAction(MonsterType.elite,level,$event)">
                    <div class="monster-action" *ngFor="let action of statsForType(MonsterType.elite,level).actions"
                      cdkDrag>
                      <ghs-action (click)="editMonsterAction(MonsterType.elite, action,level)" [action]="action"
                        [monster]="getMonsterForLevel(level)" [inline]="true" [hexSize]="0.5" [relative]="true">
                      </ghs-action>
                      <span class="handle" cdkDragHandle><img class="ghs-icon" src="./assets/images/menu.svg"></span>
                    </div>
                    <a (click)="addMonsterAction(MonsterType.elite,level)"><img class="ghs-icon"
                        src="./assets/images/plus.svg">
                      <span [ghs-label]="'editor.action.add'"></span></a>
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="monsterData.boss">
                <div class="extra boss">
                  <div class="notes" [ghs-label]="statsForType(MonsterType.boss,level).note"></div>
                  <div class="additional" cdkDropList
                    (cdkDropListDropped)="dropMonsterAction(MonsterType.boss,level,$event)">
                    <div class="monster-action" *ngFor="let action of statsForType(MonsterType.boss,level).actions"
                      cdkDrag>
                      <ghs-action (click)="editMonsterAction(MonsterType.boss, action,level)" [action]="action"
                        [monster]="getMonsterForLevel(level)" [inline]="true" [hexSize]="0.5" [relative]="true">
                      </ghs-action>
                      <span class="handle" cdkDragHandle><img class="ghs-icon" src="./assets/images/menu.svg"></span>
                    </div>
                    <a (click)="addMonsterAction(MonsterType.boss,level)"><img class="ghs-icon"
                        src="./assets/images/plus.svg">
                      <span [ghs-label]="'editor.action.add'"></span></a>
                  </div>
                  <div class="specials">
                    <div class="special"
                      *ngFor="let special of statsForType(MonsterType.boss,level).special; let index = index;">
                      <span class="index">{{index+1}}:</span>
                      <div class="actions">
                        <ng-container *ngFor="let action of statsForType(MonsterType.boss,level).special[index]">
                          <ghs-action (click)="editSpecialAction(MonsterType.boss,index, action,level)"
                            [action]="action" [monster]="getMonsterForLevel(level)" [inline]="true" [hexSize]="0.5"
                            [relative]="true">
                          </ghs-action>
                        </ng-container>
                        <a (click)="addSpecialAction(MonsterType.boss, index,level)"><img class="ghs-icon"
                            src="./assets/images/plus.svg"> <span [ghs-label]="'editor.action.add'"></span></a>
                      </div>
                    </div>
                    <a
                      (click)="addSpecialAction(MonsterType.boss, statsForType(MonsterType.boss,level).special.length,level)"><img
                        class="ghs-icon" src="./assets/images/plus.svg">
                      <span [ghs-label]="'editor.monster.stats.addSpecial'"></span>
                    </a>
                  </div>
                </div>
              </ng-container>
            </div>

            <ghs-monster-stats class="stats-preview" [monster]="getMonsterForLevel(level)" [forceStats]="true"
              [relative]="true" [noClick]="true">
            </ghs-monster-stats>
          </div>

          <a class="button" *ngIf="level != -1" (click)="applyToAllLevel(level)">
            <span [ghs-label]="'editor.monster.stats.applyAll'"></span>
          </a>
        </div>
      </div>

      <div class="output">
        <h2><span [ghs-label]="'editor.monster.stats.json'"></span>

          <select (change)="loadMonsterData($event)">
            <option [value]="-1">&lt;<span [ghs-label]="'editor.monster.new'"></span>&gt;</option>
            <option [value]="index" *ngFor="let md of monstersData; let index = index;"
              [selected]="md.edition == monsterData.edition && md.name == monsterData.name">
              <span [ghs-label]="'data.monster.' + md.name"></span> (<span
                [ghs-label]="'data.edition.' + md.edition"></span>)
              [{{md.name}}]
            </option>
          </select>

          <select [(ngModel)]="edition" (change)="updateQueryParams()">
            <option></option>
            <option *ngFor="let edition of editions" [value]="edition">
              <span [ghs-label]="'data.edition.' + edition"></span>
            </option>
          </select>

        </h2>

        <div> {{monsterError}} </div>
        <textarea #inputMonsterData></textarea>

        <a class="button" [href]="'data:application/json;charset=utf-8,' + encodeURIComponent(inputMonsterData.value)"
          [download]="monsterData.name + '.json'"><img class="ghs-icon" src="./assets/images/export.svg">
          <span [ghs-label]="'editor.monster.stats.json.download'"></span></a>
      </div>
    </div>

    <ghs-deck-editor *ngIf="init" #deckEditor [monster]="getMonsterForLevel(level)" [standalone]="false"
      [edition]="edition">
    </ghs-deck-editor>
  </div>
</div>